import { api, makeApiRequest } from './_init'

const secretsApi = {
  fetchServiceTypesAsync: async () => {
    return await makeApiRequest(api, 'get', '/secrets/services')
  },
  fetchSecretsAsync: async () => {
    return await makeApiRequest(api, 'get', '/secrets')
  },
  createSecretAsync: async ({ service_name, name, raw_secret, tenant_ref }) => {
    return await makeApiRequest(api, 'post', '/secrets', {
      service_name,
      name,
      raw_secret,
      tenant_ref,
    })
  },
  deleteSecretAsync: async (secretId) => {
    return await makeApiRequest(api, 'delete', `/secrets/${secretId}`)
  },
}

export default secretsApi
